<template>
    <div class="commonTableStyles retailAudit-box">
        <HeaderNav
            header-title="零售账款确认"
            left-icon-name="3"
            right-icon-name="3"
        ></HeaderNav>
        <span class="back iconfont" @click="handleBack">&#xe607;</span>
        <div class="project-list">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <ul class="list">
                    <template v-for="(item, index) in auditList">
                        <li :key="index+item.crmid" :class="`status${item.approval_status}`">
                            <div class="engineeringInfo" @click="collectionRecordEdit(item, index)">
                                <h4 class="engineeringInfo_header">
                                    <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                    <span class="contractStatus corner-marker">{{ item.approval_status_name }}</span>
                                </h4>
                                <div class="engineeringInfo_content">
                                    <p>
                                        <span class="info">工程名称：{{ item.engineering_name }}</span>
                                    </p>
                                    <p>
                                        <span class="info">客户名称：{{ item.client_name }}</span>
                                    </p>
                                    <p>
                                        <van-col span="12">
                                            <span class="info">类型：{{ item.maintenance_type_name }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="info">方量：{{ item.capacity }}</span>
                                        </van-col>
                                    </p>
                                    <p>
                                        <van-col span="12">
                                            <span class="info">金额：{{ item.amount_money }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="info">支付方式：{{ item.payment_mode_name }}</span>
                                        </van-col>
                                    </p>
                                    <p>
                                        <span class="info">提交时间：{{ item.submit_time }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="btn-con">
                                <div v-if="item.approval_status!=2" class="btn" @click.stop="handleSure(item)">
                                    确认
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
            </van-list>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            // 暂时没分页，接口支持时可用
            pagetion: {
                pageindex: 0,
                pageSize: 4,
            },
            auditList: [],
            formData: {},
            loading: false,
            finished: false,
            total: true,
            keywords: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 暂时没分页，接口支持时可用
        onLoad() {
            this.getPage();
        },
        getPage() {
            this.$axios
                .get('/interfaceApi/sale/accounts/retail/get_audit_list')
                .then(res => {
                    this.loading = false;
                    this.auditList = res;
                    this.finished = true;// 返回全部数据暂时无分页。
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        handleSure(item) {
            Dialog.confirm({
                title: '',
                message: '该笔零售账款将被确认，是否继续？',
                confirmButtonText: '审批通过',
            })
                .then(() => {
                    // on confirm
                    this.sendSure(item.crmid).then(res => {
                        if (res) {
                            this.getPage();
                        }
                    });
                })
                .catch(() => {
                    // on cancel
                });
        },
        sendSure(crmid) {
            return this.$axios
                .post(`/interfaceApi/sale/accounts/retail/confirm/${crmid}`);
        },
        // 返回
        handleBack() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newMaterialPlan', params: { formData: this.formData } });
            this.$router.go(-1);
        },
    },

    mounted() {
    },
};
</script>
<style lang="stylus" scoped>
.retailAudit-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        .list
            li
                &.status0
                    .corner-marker
                        color #0189FC
                &.status1
                    .corner-marker
                        color #04B97F
                &.status2
                    .corner-marker
                        color #E60000
                &.status3
                    .corner-marker
                        color #E60000
                &.status4
                    .corner-marker
                        color #FF6600
                &.status5
                    .corner-marker
                        color #04A2B9
                &.status6
                    .corner-marker
                        color #979EA7
                .engineeringInfo_header
                    justify-content space-between
</style>
